import React, { useEffect, useState } from 'react';

import { Box, Flex, Text, Spinner, Button } from '@vimeo/bokeh';
import { ChevronRightSmall } from '@vimeo/bokeh-icons';

import { vimeoHCClient } from '../api/vimeoHC';
import { useHelpPanel } from '../hooks/useHelpPanel';
import { useVimeoHC } from '../hooks/useVimeoHC';
import { HelpCategory } from '../types';

export const SectionPanel: React.FC = () => {
  const { goToArticleList, data } = useHelpPanel();
  const sectionData: HelpCategory = data.section || {
    id: '',
    url: '',
    title: '',
    parentSectionId: '',
  };

  const { loading, error, execute } = useVimeoHC(vimeoHCClient.getSectionsByCategoryId);
  const [sections, setSections] = useState<HelpCategory[] | null>(null);

  useEffect(() => {
    if (sectionData.id) {
      const controller = new AbortController();
      execute(sectionData.id, controller.signal).then((result) => {
        if (result) {
          setSections(result);
        }
      });
      return () => controller.abort();
    }
  }, [sectionData.id, execute]);

  if (loading || sections === null) {
    return (
      <Flex direction="column" alignItems="center" justifyContent="center" height="100%">
        <Spinner size="lg" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Box p={4} color="status-destructive-primary">
        Failed to load section content. Please try again.
      </Box>
    );
  }

  return (
    <Flex direction="column" gap="sm">
      {sections.map((section: HelpCategory) => (
        <Flex
          as={Button}
          key={section.id}
          variant="tertiary"
          borderRadius="md"
          p="sm"
          height="100%"
          alignItems="flex-start"
          onClick={() => goToArticleList(section)}
        >
          <Text
            flex="1"
            variant="body-md"
            textAlign="left"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            minWidth="0"
          >
            {section.title}
          </Text>
          <ChevronRightSmall />
        </Flex>
      ))}
    </Flex>
  );
};
